<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  modelValue: boolean;
  title?: string;
  url?: null | string;
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Visualizar documento',
  url: null,
});

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
}>();

const hasDocument = computed(() => !!props.url);

function handleClose() {
  emit('update:modelValue', false);
}
</script>

<template>
  <div
    v-if="modelValue"
    class="modal modal-blur fade show"
    style="display: block"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Fechar"
            @click="handleClose"
          />
        </div>
        <div class="modal-body">
          <iframe
            v-if="hasDocument"
            :src="url ?? undefined"
            :title="title"
            class="document-frame"
          />
          <div v-else class="document-frame document-frame--empty text-secondary">
            Documento não disponível
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.modal-header {
  border-bottom: 1px solid #e9ecef;
  padding: 1.25rem 1.5rem;

  .modal-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
  }

  .btn-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #6c757d;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s ease;

    &:hover {
      background-color: #f8f9fa;
      color: #495057;
    }

    &::before {
      content: '×';
      font-size: 1.5rem;
      line-height: 1;
    }
  }
}

.modal-body {
  padding: 0;
}

.document-frame {
  width: 100%;
  height: 80vh;
  border: none;
  border-radius: 0 0 12px 12px;
}

.document-frame--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
}

@media (max-width: 576px) {
  .modal-dialog {
    margin: 0.5rem;
    max-width: calc(100% - 1rem);
  }

  .document-frame {
    height: 70vh;
  }
}
</style>
